import { html } from 'lit';
import { directive } from 'lit/directive.js';

import { getPracticeInformation } from '../neb-api-client/src/practice-information';
import { store } from '../neb-redux/neb-redux-store';

export const FEATURE_FLAGS = {
  CLAIMS_PLAYGROUND: 'claims-playground',
  CT_CHECK_IN_FORMS: 'ct-checkin-forms',
  CT_INFORMS: 'ct-informs',
  CT_INSIGHTS: 'ct-insights',
  ENABLE_PROVIDER_ACTIONS: 'enable-provider-actions',
  RECENT_RECORDS: 'recent-records',
  INSURANCE_CARE_PACKAGE: 'insurance-care-package',
  EXCEL_REPORT_LINK: 'excel-report-link',
  LOG_DUPLICATE_API_CALLS: 'log-duplicate-api-calls',
  LS_TAX_DISCOUNT: 'ls-tax-discount',
  LS_DISCOUNT_FEEDBACK_BUTTON: 'ls-discount-feedback-button',
  LS_PREALLOCATION_FEEDBACK_BUTTON: 'ls-preallocation-feedback-button',
  OWL_NOTIFICATIONS: 'owl-notifications',
  LS_CREDIT_PREALLOCATION: 'ls-credit-preallocation',
  LS_BULK_DISCOUNT_SELECTION: 'ls-bulk-discount-selection',
  LS_PREALLOCATION_CHECKOUT: 'ls-preallocation-checkout',
  LS_SUBSCRIPTION_MANUAL: 'ls-subscription-manual',
  TESTING_REPORT: 'testing-report',
  ENTERPRISE_REPORTS: 'enterprise-reports',
  CHECK_IN_OUT_V2: 'check-in-out-v2',
  DISABLE_INITIAL_LOAD: 'disable-initial-load',
  ZERO_CHARGE_CARE_PACKAGES: 'zero-charge-care-packages', // Used in neb-ms-billing
  RCM_SECONDARY_FIELD: 'rcm-secondary-field',
  RCM_CHANGE_SECONDARY: 'rcm-change-secondary',
  EASY_BILLING_NOTES: 'rcm-easy-billing-notes',
  RCM_QUICK_DELETE_SEARCH: 'rcm-quick-delete-search',
  RCM_CLAIM_FLAG: 'rcm-claim-flag',
  RCM_CLAIM_ACTION_HISTORY: 'rcm-claim-action-history',
  REMOVE_ALLOCATION_NAV: 'remove-allocation-nav',
  ADVANCED_PRACTICE_MENU: 'advanced-practice-menu',
  ALLOCATIONS_PATIENT_SEARCH: 'allocations-patient-search',
  APPLY_RESET_ALLOCATE_FIT: 'apply-reset-allocate-fit',
  PDF_CLEAN_UP_HTML_CONTENT: 'pdf-clean-up-html-content', // Used in neb-ms-pdf
  RTS_SCRUB: 'rts-scrub',
  RCM_RELEASE_2: 'rcm-release-2',
  SECONDARY_CLAIMS: 'rcm-secondary-claims',
  RTS_LATENCY_IMPROVEMENT: 'rts-latency-improvement',
  ITD_DOO_CLAIM_ERROR_OVERLAY: 'rcm-itd-doo-claim-error-overlay',
  MANAGE_ENCOUNTER_CLAIM_ERROR_OVERLAY:
    'rcm-manage-encounter-claim-error-overlay',
  RCM_INSURANCE_CLAIM_ERROR_OVERLAY: 'rcm-insurance-claim-error-overlay',
  PATIENT_INFO_CLAIM_ERROR_OVERLAY: 'rcm-patient-info-claim-error-overlay',
  RCM_PAYER_CLAIM_ERROR_OVERLAY: 'rcm-payer-claim-error-overlay',
  FIT_INVOICE_OVERLAY_PERFORMANCE: 'fit-invoice-overlay-performance',
  ENABLE_RUM_SESSION_REPLAY: 'enable-rum-session-replay',
  ERA_OVERVIEW_NAVIGATION_A: 'era-overview-navigation-a',
  ERA_OVERVIEW_NAVIGATION_B: 'era-overview-navigation-b',
  ERA_PERF_S3_KAFKA: 'era-perf-s3-kafka', // used in neb-ms-electronic-claims and neb-ms-billing
  EGG_CLAIMS_RESOLUTION_DOCUMENTS_TAB: 'egg-claims-resolution-documents-tab',
  DH_CHECK_OUT: 'dh-check-out',
  DH_SINGLE_CHARGE_VIEW_AUDIT_LOG: 'dh-single-charge-view-audit-log',
  EGG_FUTURE_COPY_ANY_ENCOUNTER: 'egg-future-copy-any-encounter',
  CLAIM_TOTALS_V2: 'claim-totals-v2',
  OWL_ERA_EOB_REMOVE_EDIT_CHARGES: 'owl-era-eob-remove-edit-charges',
  PAYMENT_DETAILS_BETA: 'payment-details-beta', // Used in neb-ms-reports,
  END_OF_DAY_SUMMARY_BETA: 'end-of-day-summary-beta',
  END_OF_DAY_TRANSACTIONS_BETA: 'end-of-day-transactions-beta',
  OWL_ALLOCATION_PAGE_PERFORMANCE: 'owl-allocation-page-performance',
  EGG_AR_HUB_TAB: 'egg-ar-hub-tab',
  EGG_OPTIMIZE_AR_HUB_INVOICES: 'egg-optimize-ar-hub-invoices',
  OWL_ERA_ACTIONS_ENHANCEMENTS: 'owl-era-actions-enhancements',
  LS_NEW_SCAN_VERSION: 'ls-new-scan-version',
  LS_SCAN_MULTI_VERSION: 'ls-scan-multi-version',
  LS_SCAN_API_CACHE: 'ls-scan-api-cache',
  OWL_PAYER_PLAN_CACHE: 'owl-payer-plan-cache',
  OWL_PAYER_PLAN_JOIN: 'owl-payer-plan-join',
  EGG_FIT_REPORT: 'egg-fit-report',
  EGG_DATE_OF_ONSET: 'egg-date-of-on-set',
  OWL_REMIT_OFFSET_AUTOMATIC_CREATION: 'owl-remit-offset-automatic-creation',
  OWL_PREVIEW_ALLOCATIONS_PERFORMANCE: 'owl-preview-allocations-performance',
  EGG_AVOID_DATA_CORRUPTION_FOR_CHARGES_FROM_ARCHIVED_ENCOUNTERS:
    'egg-avoid-data-corruption-for-charges-from-archived-encounters',
  DH_CHARGE_UNITS: 'dh-charge-units',
  LS_OPEN_PAYMENTS_V2: 'ls-open-payments-v2',
  OMEGA_INITIAL_ALLOCATION_PERFORMANCE: 'omega-initial-allocation-performance',
  OMEGA_CHRONOLOGICAL_EFFECTIVE_DATE: 'omega-chronological-effective-date',
  LS_PREALLOCATION_FAMILY: 'ls-preallocation-family',
  OWL_2FA_ENABLEMENT: 'owl-2fa-enablement',
  EGG_SCHEDULING_BUTTON_MENU: 'egg-scheduling-button-menu',
  EGG_USER_AGREEMENT_POPUP: 'egg-user-agreement-popup',
  OWL_ERA_DISABLE_WRITE_OFF: 'owl-era-disable-write-off', // Used in neb-ms-billing,
  OMEGA_VALIDATE_PAYMENT_ALLOCATION_V2: 'omega-validate-payment-allocation-v2',
  LS_CAREPACKAGE_ENHANCEMENTS: 'ls-carepackage-enhancements',
  OWL_PATIENT_RELATIONSHIPS_PERFORMANCE:
    'owl-patient-relationships-performance',
  AUDIT_SHIELD: 'audit-shield',
  OMEGA_ERA_SPREADSHEET: 'omega-era-spreadsheet',
  OWL_HIDE_2FA_SMS: 'owl-hide-2fa-sms',
  OMEGA_REPLACE_PAYER: 'omega-replace-payer',
  EGG_PROGRESSION_OF_CARE: 'egg-progression-of-care',
  OMEGA_DENIED_REJECTED_CLAIMS: 'omega-denied-rejected-claims',
  EGG_AI_BUTTON_DROPDOWN: 'egg-ai-button-dropdown',
  LS_CP_ALLOW_DUPLICATE_NAME: 'ls-cp-allow-duplicate-name', // Used in neb-ms-billing
  AS_AMBIENT_SCRIBE: 'as-ambient-scribe',
  AS_AMBIENT_SCRIBE_TEMPLATE: 'as-ambient-scribe-template',
  AS_AMBIENT_SCRIBE_HOME: 'as-ambient-scribe-home',
  OMEGA_ERA_HANDLING: 'omega-era-handling',
  OMEGA_GET_LINE_ITEMS_FOR_ALLOCATION_V2:
    'omega-get-line-items-for-allocation-v2', // Used in neb-ms-billing
  LS_DEBOUNCE_FETCH_SUGGESTIONS_VIA_COUNT:
    'ls-debounce-fetch-suggestions-via-count',
  LS_DEBOUNCE_FETCH_SUGGESTIONS_VIA_DELAY:
    'ls-debounce-fetch-suggestions-via-delay',
  EGG_PROGRESSION_OF_CARE_FILTER: 'egg-progression-of-care-filter',
  EGG_AI_CHARTING_ASSISTANT: 'egg-ai-charting-assistant',
};

export const FEATURE_FLAGS_ON_PRODUCTION = [
  FEATURE_FLAGS.ALLOCATIONS_PATIENT_SEARCH,
  FEATURE_FLAGS.CODE_SEARCH,
  FEATURE_FLAGS.EASY_BILLING_NOTES,
  FEATURE_FLAGS.EGG_CLAIMS_RESOLUTION_DOCUMENTS_TAB,
  FEATURE_FLAGS.ITD_DOO_CLAIM_ERROR_OVERLAY,
  FEATURE_FLAGS.LS_RENAME_CARD_DESCRIPTION,
  FEATURE_FLAGS.PAYMENT_FREQUENCY,
  FEATURE_FLAGS.MANAGE_ENCOUNTER_CLAIM_ERROR_OVERLAY,
  FEATURE_FLAGS.PATIENT_INFO_CLAIM_ERROR_OVERLAY,
  FEATURE_FLAGS.SECONDARY_CLAIMS,
  FEATURE_FLAGS.ZERO_CHARGE_CARE_PACKAGES,
];

export const RCM_FEATURE_FLAGS = [
  FEATURE_FLAGS.RCM_CHANGE_SECONDARY,
  FEATURE_FLAGS.RCM_CLAIM_ACTION_HISTORY,
  FEATURE_FLAGS.RCM_CLAIM_FLAG,
  FEATURE_FLAGS.RCM_INSURANCE_CLAIM_ERROR_OVERLAY,
  FEATURE_FLAGS.RCM_PAYER_CLAIM_ERROR_OVERLAY,
  FEATURE_FLAGS.RCM_QUICK_DELETE_SEARCH,
  FEATURE_FLAGS.RCM_RELEASE_2,
  FEATURE_FLAGS.RCM_SECONDARY_FIELD,
  FEATURE_FLAGS.EGG_CLAIMS_RESOLUTION_DOCUMENTS_TAB,
];

export const INTEGRATION_FEATURE_FLAGS = [];

const lookupPracticeInfo = () =>
  store.getState().practiceInformation.item
    ? store.getState().practiceInformation.item
    : store.getState().practiceInfo.practiceInfoItems[0];

export const hasFeatureOrBeta = async feature => {
  let practiceInfo;

  while (!practiceInfo) {
    practiceInfo = lookupPracticeInfo();

    if (!practiceInfo) await new Promise(resolve => setTimeout(resolve, 200));
  }

  return !!practiceInfo.features && practiceInfo.features.includes(feature);
};

export const supporthasFeatureOrBeta = async (tenantId, feature) => {
  let practiceInfo;

  while (!practiceInfo || practiceInfo === {}) {
    practiceInfo = await getPracticeInformation(tenantId);

    if (practiceInfo === {}) {
      await new Promise(resolve => setTimeout(resolve, 200));
    }
  }

  return !!practiceInfo.features && practiceInfo.features.includes(feature);
};

export const featureGate = directive(
  (featureName, withFeature, withoutFeature = html``) =>
    part => {
      hasFeatureOrBeta(featureName).then(enabled => {
        if (enabled) {
          part.setValue(withFeature);
        } else {
          part.setValue(withoutFeature);
        }

        part.commit();
      });
    },
);

export const getFeatures = async () => {
  let practiceInfo;

  while (!practiceInfo) {
    practiceInfo = lookupPracticeInfo();

    if (!practiceInfo) await new Promise(resolve => setTimeout(resolve, 200));
  }

  return practiceInfo.features || [];
};

export const hasFeatureOrBetaSync = feature => {
  const practiceInfo = lookupPracticeInfo();
  return (
    !!practiceInfo &&
    !!practiceInfo.features &&
    practiceInfo.features.includes(feature)
  );
};

export const hasTierSync = tier => {
  const practiceInfo = lookupPracticeInfo();

  return !!practiceInfo && practiceInfo.tier === tier;
};
